import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/public/ui";

export default function Products() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("");
  useEffect(() => {
    api.get("/products").then(({ data }) => setItems(data)).catch(() => {});
    api.get("/product_categories").then(({ data }) => setCats(data)).catch(() => {});
  }, []);
  const filtered = active ? items.filter((p) => p.category === active) : items;
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 relative">
          <Overline><span className="text-[#4CB944]">Catalogue Hardware</span></Overline>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-white font-head">Matériel informatique</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl">Ordinateurs, serveurs, réseau, sécurité et accessoires des plus grandes marques.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-wrap gap-2 mb-8">
          <button onClick={() => setActive("")} className={`px-4 py-2 rounded-full text-sm font-medium ${!active ? "bg-[#0F2A6B] text-white" : "bg-white border border-slate-200 text-slate-600"}`}>Tous</button>
          {cats.map((c) => (
            <button key={c.id} data-testid={`product-filter-${c.slug}`} onClick={() => setActive(c.name)} className={`px-4 py-2 rounded-full text-sm font-medium ${active === c.name ? "bg-[#0F2A6B] text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-[#0F2A6B]/30"}`}>{c.name}</button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="products-grid">
          {filtered.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.05}>
              <Link to={`/produits/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block h-full rounded-2xl bg-white border border-slate-200 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all">
                <div className="relative h-48 bg-slate-50 overflow-hidden">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  {p.featured && <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-[#4CB944] text-white text-xs font-semibold">Vedette</span>}
                </div>
                <div className="p-5">
                  <div className="text-xs font-mono text-slate-400 uppercase">{p.brand} · {p.category}</div>
                  <h3 className="mt-1 font-semibold text-slate-900">{p.name}</h3>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-[#0F2A6B] font-bold">{p.price}</span>
                    <span className={`text-xs px-2 py-1 rounded-full ${p.availability === "En stock" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>{p.availability}</span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
          {filtered.length === 0 && <p className="text-slate-500">Aucun produit.</p>}
        </div>
      </section>
    </div>
  );
}
